/* TODO: Only prop combinations from Figma are styled. Other combinations do not work. */
.tag {
  display: inline-flex;
  align-items: center;
  height: var(--rc-theme-react-components-tag-height-sm);
  padding: var(--rc-theme-spacing-xxxs) var(--rc-theme-spacing-xs);
  border-color: transparent;
}

.tag.tag .tag__content {
  margin-inline-start: var(--rc-theme-spacing-xxs);
}

.tag--no-background:not(.tag--bordered) {
  background: none;
}

.tag.tag--bordered {
  border: var(--rc-theme-border-base);
  background-color: unset;
  color: var(--rc-theme-color-text-default);
}

.tag--uppercase {
  text-transform: uppercase;
}

.tag.tag--size-default {
  font-size: var(--rc-theme-font-size-text-sm);
}

.tag.tag--size-compact {
  height: var(--rc-theme-react-components-tag-height-xs);
  padding: 0 var(--rc-theme-spacing-xxs);
}

.tag.tag--no-padding {
  height: auto;
  padding: 0;
}

.tag.tag--size-medium {
  font-size: var(--rc-theme-font-size-text-base);
}

.tag--size-medium .tag__icon {
  font-size: var(--rc-theme-font-size-text-lg);
}

.tag--color-caution {
  background-color: var(--rc-theme-color-caution-background);
}

.tag--color-caution .tag__icon {
  color: var(--rc-theme-color-caution-default);
}

.tag--colored-content.tag--color-caution {
  color: var(--rc-theme-color-caution-default);
}

.tag--color-critical {
  background-color: var(--rc-theme-color-error-default);
  color: var(--rc-theme-color-surface-default);
}

.tag--color-critical .tag__icon {
  color: var(--rc-theme-color-surface-default);
}

.tag--color-critical .tag__badge-text {
  color: var(--rc-theme-color-surface-default);
}

.tag--colored-content.tag--color-critical {
  color: var(--rc-theme-color-surface-default);
}

.tag--color-cyan {
  background-color: var(--rc-theme-color-cyan-background);
}

.tag--color-cyan .tag__icon {
  color: var(--rc-theme-color-cyan-default);
}

.tag--colored-content.tag--color-cyan {
  color: var(--rc-theme-color-cyan-default);
}

.tag--color-error {
  background-color: var(--rc-theme-color-error-background);
}

.tag--color-error .tag__icon {
  color: var(--rc-theme-color-error-default);
}

.tag--colored-content.tag--color-error {
  color: var(--rc-theme-color-error-default);
}

.tag--color-info {
  background-color: var(--rc-theme-color-info-background);
}

.tag--color-info .tag__icon {
  color: var(--rc-theme-color-info-default);
}

.tag--colored-content.tag--color-info {
  color: var(--rc-theme-color-info-default);
}

.tag--color-neutral {
  background-color: var(--rc-theme-color-surface-subtle);
}

.tag--color-neutral .tag__icon {
  color: var(--rc-theme-color-text-default);
}

.tag--colored-content.tag--color-neutral {
  color: var(--rc-theme-color-text-default);
}

.tag--color-success {
  background-color: var(--rc-theme-color-success-background);
}

.tag--color-success .tag__icon {
  color: var(--rc-theme-color-success-default);
}

.tag--colored-content.tag--color-success {
  color: var(--rc-theme-color-success-default);
}

.tag--color-warning {
  background-color: var(--rc-theme-color-warning-background);
}

.tag--color-warning .tag__icon {
  color: var(--rc-theme-color-warning-default);
}

.tag--colored-content.tag--color-warning {
  color: var(--rc-theme-color-warning-default);
}

.tag--color-blue {
  background-color: var(--rc-theme-color-blue-background);
}

.tag--color-blue .tag__icon,
.tag--colored-content.tag--color-blue {
  color: var(--rc-theme-color-blue-default);
}

.tag--color-green {
  background-color: var(--rc-theme-color-green-background);
}

.tag--color-green .tag__icon,
.tag--colored-content.tag--color-green {
  color: var(--rc-theme-color-green-default);
}

.tag--color-orange-dark {
  background-color: var(--rc-theme-color-orange-dark-background);
}

.tag--color-orange-dark .tag__icon,
.tag--colored-content.tag--color-orange-dark {
  color: var(--rc-theme-color-orange-dark-default);
}

.tag--color-orange-light {
  background-color: var(--rc-theme-color-orange-light-background);
}

.tag--color-orange-light .tag__icon,
.tag--colored-content.tag--color-orange-light {
  color: var(--rc-theme-color-orange-light-default);
}

.tag--color-pink {
  background-color: var(--rc-theme-color-pink-background);
}

.tag--color-pink .tag__icon,
.tag--colored-content.tag--color-pink {
  color: var(--rc-theme-color-pink-default);
}

.tag--color-purple {
  background-color: var(--rc-theme-color-purple-background);
}

.tag--color-purple .tag__icon,
.tag--colored-content.tag--color-purple {
  color: var(--rc-theme-color-purple-default);
}
